import { render, staticRenderFns } from "./KSRMessageToBodyshop.vue?vue&type=template&id=d0dd5520&"
import script from "./KSRMessageToBodyshop.vue?vue&type=script&lang=js&"
export * from "./KSRMessageToBodyshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports